import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=1fa5c183&scoped=true&lang=pug"
import script from "./CategoryTable.vue?vue&type=script&lang=ts"
export * from "./CategoryTable.vue?vue&type=script&lang=ts"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=1fa5c183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5c183",
  null
  
)

export default component.exports